module.exports = __webpack_public_path__ + "img/img-main.179ab7f4.webp";